import '../../App.css';
import Stack from '@mui/material/Stack';
import { jsonToTable } from '../../utils/StringUtils';
import Box from '@mui/material/Box';

const RawBoard1Tab = (props) => {
    const { packet } = props;
    
    return (
        <>
            <Stack direction='row' spacing={1}>
                {(packet.board1 !== null) && (
                    <>
                        <Box key="Header">
                            Header
                            {jsonToTable(packet.board1.header)}
                        </Box>
                        <Box key="SIV">
                            SIV
                            {jsonToTable(packet.board1.siv)}
                        </Box>
                        <Box key="BCU">
                            BCU
                            {jsonToTable(packet.board1.bcu)}
                        </Box>
                        <Box key="VAC">
                            VAC
                            {jsonToTable(packet.board1.vac)}
                        </Box>
                        <Box key="DOOR1">
                            DOOR1
                            {jsonToTable(packet.board1.door1)}
                        </Box>
                        <Box key="DOOR2">
                            DOOR2
                            {jsonToTable(packet.board1.door2)}
                        </Box>
                        <Box key="DOOR3">
                            DOOR3
                            {jsonToTable(packet.board1.door3)}
                        </Box>
                        <Box key="Time">
                            Time
                            {jsonToTable(packet.board1.time)}
                        </Box>
                        <Box key="Misc">
                            Misc
                            {jsonToTable(packet.board1.misc)}
                        </Box>
                        <Box key="VDV">
                            VDV
                            {jsonToTable(packet.board1.vdv)}
                        </Box>
                        <Box key="Extra1">
                            Extra1
                            {jsonToTable(packet.board1.extra1)}
                        </Box>
                    </>
                )}
            </Stack>
        </>
    );
};

export default RawBoard1Tab;